import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useThemeMode } from '../../../../hooks'
import { isThemeDark } from '../../../../utils/themeMode'
import Button from '../../../Button'
import { ScrollContainer } from '../../../ScrollContainer'

import { AttachedFiles } from './AttachedFiles'
import { EmailMessageTags } from './EmailMessageTags'
import { QA_NAME_EMAIL_THEME_VIEW_BUTTON } from './EmailProfileMessageBody.constants'
import { getMessageTree } from './EmailProfileMessageBody.utils'
import { FooterActions } from './FooterActions'
import { ViewEntireMessageButton } from './ViewEntireMessageButton'

import * as styles from './EmailProfileMessageBody.module.css'

function EmailProfileMessageBody({
  attachedFilesProps,
  className = styles.EmailProfileMessageBody,
  data,
  footerActionsProps,
  onClickRemoveCopiedEntity,
  onViewEntireMessage,
}) {
  const {
    files,
    has_raw_text: hasRawText,
    permissions: { can_reply: canReply },
    text,
  } = data

  const { t } = useTranslation()

  const { theme } = useThemeMode()

  const [isLightView, setLightView] = useState(false)

  const isDark = isThemeDark(theme)

  const messageTree = getMessageTree(text, { isDark: isDark && !isLightView })

  function handleClickThemeView() {
    setLightView(prevLightView => !prevLightView)
  }

  return (
    <div className={className}>
      <EmailMessageTags
        data={data}
        onClickRemoveCopiedEntity={onClickRemoveCopiedEntity}
      />

      <ScrollContainer className={styles.messageContainer}>
        {isDark ? (
          <div className={styles.themeView}>
            <Button.Text
              qaName={QA_NAME_EMAIL_THEME_VIEW_BUTTON}
              text={t(
                isLightView
                  ? 'EmailProfile.ShowInDarkKey'
                  : 'EmailProfile.ShowInLightKey'
              )}
              onClick={handleClickThemeView}
            />
          </div>
        ) : null}

        {isDark && isLightView ? (
          <div className={styles.paperView}>{messageTree}</div>
        ) : (
          messageTree
        )}

        {hasRawText ? (
          <ViewEntireMessageButton onClick={onViewEntireMessage} />
        ) : null}
        <FooterActions {...footerActionsProps} canReply={canReply} />
      </ScrollContainer>

      {files.length > 0 ? (
        <AttachedFiles {...attachedFilesProps} files={files} />
      ) : null}
    </div>
  )
}

export default EmailProfileMessageBody
